document.addEventListener("DOMContentLoaded", () => {
  if (window.__nmFreebieLoaderBound) return;
  window.__nmFreebieLoaderBound = true;

  const FREEBIE_IDS = [42370639233101, 42371315368013, 42370643034189];
  const MAIN_VARIANT_ID = 41905203249229;

  let skeletonCheckInterval;
  let lastHasMain = false;
  let lastMainAddedAt = 0;
  let forcedVisible = false;
  let observerTimeout = null;
  const STATUS_BANNER_SOURCE = "freebie-loader";

  function getStatusBannerState() {
    if (!window.__freebieStatusBannerState) {
      window.__freebieStatusBannerState = {
        activeSources: new Set(),
        hideTimer: null,
        isVisible: false,
        sourceShownAt: {},
      };
    }
    if (!window.__freebieStatusBannerState.sourceShownAt) {
      window.__freebieStatusBannerState.sourceShownAt = {};
    }
    return window.__freebieStatusBannerState;
  }

  function ensureSkeletonContainer() {
    let container = document.querySelector("#freebie-skeleton-container");
    if (!container) {
      const wrapper = document.querySelector(".drawer__cart-items-wrapper");
      if (!wrapper) return null;

      container = document.createElement("div");
      container.id = "freebie-skeleton-container";
      container.innerHTML = `
        ${[1, 2, 3].map(() => `
          <div class="freebie-skeleton">
            <div class="skeleton-left">
              <div class="skeleton-thumb"></div>
              <div class="skeleton-lines">
                <div class="line long"></div>
                <div class="line medium"></div>
                <div class="line short"></div>
              </div>
            </div>
            <div class="skeleton-price"></div>
          </div>
        `).join("")}
      `;
      wrapper.prepend(container);
    }
    return container;
  }

  function ensureStatusBanner() {
    let banner = document.querySelector("#freebie-status-banner");
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "freebie-status-banner";
      banner.textContent = "🎁 Adding your free gifts…";
      document.querySelector(".drawer__cart-items-wrapper")?.prepend(banner);
    }
    const state = getStatusBannerState();
    banner.classList.toggle("visible", state.isVisible);
    return banner;
  }

  function setStatusBannerVisible(banner, isVisible) {
    const state = getStatusBannerState();
    const hideCurrentBanners = () => {
      state.isVisible = false;
      document
        .querySelectorAll("#freebie-status-banner")
        .forEach((el) => el.classList.remove("visible"));
    };
    const scheduleHide = (delay) => {
      state.hideTimer = setTimeout(() => {
        const now = Date.now();
        const hasFreshSource = Array.from(state.activeSources).some(
          (source) => now - (state.sourceShownAt[source] || 0) < 1800,
        );
        if (hasFreshSource) {
          scheduleHide(300);
        } else {
          state.activeSources.clear();
          state.sourceShownAt = {};
          hideCurrentBanners();
          state.hideTimer = null;
        }
      }, delay);
    };

    if (isVisible) {
      clearTimeout(state.hideTimer);
      state.hideTimer = null;
      state.activeSources.add(STATUS_BANNER_SOURCE);
      state.sourceShownAt[STATUS_BANNER_SOURCE] = Date.now();
      state.isVisible = true;
      banner.classList.add("visible");
      return;
    }

    state.activeSources.delete(STATUS_BANNER_SOURCE);
    delete state.sourceShownAt[STATUS_BANNER_SOURCE];
    clearTimeout(state.hideTimer);
    state.hideTimer = null;
    if (!state.isVisible) {
      banner.classList.remove("visible");
      return;
    }

    scheduleHide(300);
  }

  function restoreStatusBannerVisibility() {
    const state = getStatusBannerState();
    if (!state.isVisible) return;
    ensureStatusBanner().classList.add("visible");
  }

  function showSkeleton(container, banner) {
    if (!container || !banner) return;
    container.classList.add("active");
    container.querySelectorAll(".freebie-skeleton").forEach(el => el.classList.add("active"));
    setStatusBannerVisible(banner, true);
  }

  function hideSkeleton(container, banner) {
    if (!container || !banner) return;
    container.classList.remove("active");
    container.querySelectorAll(".freebie-skeleton").forEach(el => el.classList.remove("active"));
    setStatusBannerVisible(banner, false);
  }

  async function checkCartForFreebies() {
    const container = ensureSkeletonContainer();
    const banner = ensureStatusBanner();
    if (!container || !banner) return;

    try {
      const res = await fetch("/cart.js", { cache: "no-store" });
      const cart = await res.json();
      const hasMain = cart.items.some(i => i.variant_id === MAIN_VARIANT_ID);
      const freebiesInCart = cart.items.filter(i => FREEBIE_IDS.includes(i.variant_id) && i.final_line_price === 0);
      const freebieCount = freebiesInCart.length;
      const allFreebiesLoaded = freebieCount === FREEBIE_IDS.length;
      const now = Date.now();

      // 🎯 Detect when the main product was just added
      if (hasMain && !lastHasMain) {
        lastMainAddedAt = now;
        forcedVisible = true;
        showSkeleton(container, banner);
        setTimeout(() => forcedVisible = false, 2000); // keep visible minimum 2s
      }

      // hide after freebies are all loaded
      if (allFreebiesLoaded && !forcedVisible) {
        hideSkeleton(container, banner);
        clearInterval(skeletonCheckInterval);
      }

      // if main removed or cart empty
      if (!hasMain) {
        hideSkeleton(container, banner);
        clearInterval(skeletonCheckInterval);
      }

      lastHasMain = hasMain;
    } catch (err) {
      console.warn("⚠️ Freebie skeleton check failed:", err);
    }
  }

  function startSkeletonWatcher() {
    clearInterval(skeletonCheckInterval);
    restoreStatusBannerVisibility();
    setTimeout(checkCartForFreebies, 400);
    skeletonCheckInterval = setInterval(checkCartForFreebies, 1000);
  }

  document.addEventListener("cart:updated", startSkeletonWatcher);
  document.addEventListener("cart:refresh", startSkeletonWatcher);
  document.addEventListener("shopify:section:load", startSkeletonWatcher);

  // Safe MutationObserver to restart watcher after drawer redraws
  const observer = new MutationObserver(() => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      if (document.querySelector("#CartDrawer")) startSkeletonWatcher();
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  startSkeletonWatcher();
});
